import { App } from './app'
import 'firebase/functions'

export const Functions = App.functions()
